import siteConfig from '@/config.json'

const storageKey = () => `${siteConfig.key}Auth`

export function getStoredSession() {
  let session
  try {
    const auth = localStorage.getItem(storageKey())
    if (!auth) return null
    session = JSON.parse(auth)
  } catch (error) {
    console.log('error reading session data', error)
  }

  if (!session || typeof session.token !== 'string' || !session.token) {
    clearStoredSession()
    return null
  }
  return session
}

export function clearStoredSession() {
  try {
    localStorage.removeItem(storageKey())
  } catch (error) {
    console.log('error clearing session data', error)
  }
}

export function tokenClaims(token) {
  try {
    const payload = token.split('.')[1]
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')))
  } catch (error) {
    return null
  }
}

export function isSessionExpired(session, now = Date.now()) {
  if (session.expires && session.expires < now) return true
  const claims = tokenClaims(session.token)
  if (!claims) return true
  return typeof claims.exp === 'number' && claims.exp * 1000 < now
}
